import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { RenderField } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { normalizeValueInRange } from '../../../common/form/commonNormalizations';

const RenderNewTableFields = ({ newTable, fieldIndex, fields }) => (
  <div className="new-table-row">
    <div className="new-table-row">
      <Field
        className="table-field"
        component={RenderField}
        name={`${newTable}.num_tables`}
        label="Number of Tables"
        type="number"
        id="event-name"
        placeholder="10"
        normalize={normalizeValueInRange(1, 100)}
        validate={Validations.REQUIRED}
        required
      />
      <Field
        className="table-field"
        component={RenderField}
        name={`${newTable}.num_seats`}
        label="Number of Seats"
        type="number"
        placeholder="8"
        normalize={normalizeValueInRange(1, 99)}
        validate={Validations.REQUIRED}
        required
      />
    </div>
    {fieldIndex !== 0 && (
      <div className="onboarding-trashcan" role="button">
        <i className="zolaicon zolaicon-trashcan" onClick={() => fields.remove(fieldIndex)} />
      </div>
    )}
  </div>
);

RenderNewTableFields.propTypes = {
  newTable: PropTypes.string,
  fieldIndex: PropTypes.number,
  fields: PropTypes.shape({}),
};

export default RenderNewTableFields;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/util/RenderNewTableFields.jsx